// set globally used, static values here, not in redux

// set appConfig
window.appConfig = {
  version: 5.3
};

export {};
